import { Router } from '@angular/router';
import { MODULE_LIST } from '@contracts';
import { ModuleStore, normalizeRole, SessionStore } from '@core';
import { map, Observable } from 'rxjs';

export const getModuleMenu = (
  moduleStore: ModuleStore,
  sessionStore: SessionStore,
  router: Router,
  availableModules: any[],
): Observable<MODULE_LIST[]> => {
  return sessionStore.getRole$().pipe(
    map((userRole) =>
      availableModules
        .filter((m) => {
          if (!m.roles || m.roles.length === 0) return true;
          return m.roles.some(
            (role: string) => normalizeRole(role) === normalizeRole(userRole),
          );
        })
        .map((m) => ({
          id: m.id,
          label: m.label,
          icon: m.icon,
          icon_active: m.icon_active,
          route: m.route,
          disabled: m.disabled,
          type: m.type,
          action: () => {
            if (m.disabled) return;

            if (m.type === 'module') {
              moduleStore.setModule(m.id);
              router.navigateByUrl('/', { replaceUrl: true });
              return;
            }
          },
        })),
    ),
  );
};
